import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { SecondaryHeader, PrimaryHeader, NavBackButton, BackIcon } from '../styles/global'
import { submitIntervention } from '../utils/api.utils'
import TextField from '@material-ui/core/TextField'
import Fab from '@material-ui/core/Fab';

interface Props {
  intervention: any
  simulation?: any | undefined
  shouldDisplay: any
  fetchInterventions: any
}

export function InterventionEditor({ intervention, simulation, shouldDisplay, fetchInterventions }: Props) {
  const [currentIntervention, setIntervention] = useState(intervention);

  const isValid = currentIntervention.name !== ''

  useEffect(() => {
    setIntervention((targetIntervention: any) => ({
      ...targetIntervention,
      name: targetIntervention.name || '',
      parameters: targetIntervention.parameters || ''
    }))
  }, []);

  function saveIntervention() {
    submitIntervention(currentIntervention)
      .then((response: any) => {
        fetchInterventions()
        shouldDisplay(false)
        return response
      }).catch((err: any) => console.error(err))
  }

  return (
    <EditorWrapper>
      <EditorHeader>
        <NavBackButton startIcon={<BackIcon />} onClick={() => shouldDisplay(false)}>
          Back to Interventions
        </NavBackButton>
        <PrimaryHeader style={{ margin: 0 }}>
          {currentIntervention.id ? 'Edit Intervention' : 'New Intervention'}
        </PrimaryHeader>
      </EditorHeader>

      <SectionWrapper>
        <SecondaryHeader>General Information</SecondaryHeader>
        <FormCard>
          <FieldGroup>
            <Label>Intervention Name *</Label>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="e.g. Social Distancing"
              value={currentIntervention.name || ""}
              onChange={(e) => {
                const value = e.target.value
                setIntervention((current: any) => ({ ...current, name: value }))
              }}
            />
          </FieldGroup>
        </FormCard>
      </SectionWrapper>

      <SectionWrapper style={{ marginBottom: '100px' }}>
        <SecondaryHeader>Parameters (JSON)</SecondaryHeader>
        <FormCard>
          <FieldGroup>
            <Label>Configuration Object</Label>
            <TextField
              fullWidth
              multiline
              minRows={10}
              variant="outlined"
              placeholder='{ "key": "value" }'
              value={currentIntervention.parameters || ""}
              onChange={(e) => {
                const value = e.target.value
                setIntervention((current: any) => ({ ...current, parameters: value }))
              }}
              inputProps={{
                style: {
                  fontFamily: "'Roboto Mono', monospace",
                  fontSize: '14px',
                  lineHeight: '1.6',
                }
              }}
            />
            <HelpText>Enter the intervention parameters in JSON format. Ensure the structure matches the system requirements.</HelpText>
          </FieldGroup>
        </FormCard>
      </SectionWrapper>

      <FabWrapper
        variant="extended"
        color="primary"
        disabled={!isValid}
        onClick={() => saveIntervention()}
      >
        SAVE INTERVENTION
      </FabWrapper>
    </EditorWrapper>
  );
}

const EditorWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding-bottom: 50px;
`;

const EditorHeader = styled.div`
  margin-bottom: 40px;
`;



const SectionWrapper = styled.div`
  margin-bottom: 40px;
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`;

const FieldGroup = styled.div`
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const HelpText = styled.p`
  font-size: 12px;
  color: #718096;
  margin-top: 8px;
  font-style: italic;
`;

const FabWrapper = styled(Fab)`
  && {
    position: fixed;
    right: 40px;
    bottom: 40px;
    background-color: #3f51b5;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0 32px;
    box-shadow: 0 10px 15px -3px rgba(63, 81, 181, 0.4);
    &:hover {
      background-color: #303f9f;
    }
  }
`;
